// extracted by mini-css-extract-plugin
export default {"row":"u5xz4YJgaDhzqH6RIFm6ow=="};